import { render } from "./VoiceOfGod.vue?vue&type=template&id=58a0bb86&scoped=true"
import script from "./VoiceOfGod.vue?vue&type=script&lang=js"
export * from "./VoiceOfGod.vue?vue&type=script&lang=js"

import "./VoiceOfGod.vue?vue&type=style&index=0&id=58a0bb86&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a0bb86"]])

export default __exports__